import MDBox from "../../../components/MDBox";
import DataTable from "../../../examples/Tables/DataTable";
import { useDispatch, useSelector } from "react-redux";
import { getLanguageList } from "../../../actions/language";
import { useEffect } from "react";
import { Avatar, Grid } from "@mui/material";
import { get as _get } from "lodash";
import MDTypography from "../../../components/MDTypography";
import { Card } from "@material-ui/core";

const LanguagesList = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getLanguageList());
  }, [dispatch]);

  const storeProps = useSelector((state) => {
    return {
      data: _get(state, "language.list", []),
    };
  });

  const tableData = {
    columns: [
      {
        Header: "flag",
        accessor: "flag",
        Cell: (row) => (
          <Avatar
            alt="flag"
            variant="square"
            src={_get(row, "row.original.flag")}
            sx={{ height: "auto", width: "auto", maxWidth: "45px",  objectFit: "cover", borderRadius: "6px", mt: 1 }}
          />
        ),
        align: "left",
        width: "5%",
      },
      {
        Header: "language",
        accessor: "label",
        Cell: (row) => (
          <MDTypography Variant="caption" color="text" fontWeight="regular" fontSize="14px">
            {_get(row, "row.original.label")}
          </MDTypography>
        ),
        align: "left",
      },
    ],

    rows: _get(storeProps, "data", []),
  };

  const { columns, rows } = tableData;

  return (
    <MDBox>
      
      <DataTable
        table={{ columns, rows }}
        isSorted={false}
        entriesPerPage={false}
        showTotalEntries={false}
        noEndBorder
        //   canSearch
        forSettings
      />
    </MDBox>
  );
};

export default LanguagesList;
